import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { connect } from 'react-redux';

import { push } from 'react-router-redux';

import Project from './Project';

import { AuthActions } from '../../actions/auth';
import { ProjectActions } from '../../actions/project';
import { UserActions } from '../../actions/user';
import { ElementTypeActions } from '../../actions/elementType';
import { RelationshipTypeActions } from '../../actions/relationshipType';
import {
  currentProjectSelector,
  currentProjectIdSelector,
  projectsSelector,
} from '../../reducers/projects';
import {
  currentUserSelector,
  usersSelector,
  userModeSelector,
  getUserModeByProjectId,
} from '../../reducers/users';

const projectContainerSelector = immutableCreatorSelector(
  [
    currentProjectSelector,
    usersSelector,
    currentProjectIdSelector,
    userModeSelector,
    projectsSelector,
    currentUserSelector,
  ],
  (project, users, currentProjectId, userMode, projects, currentUser) => ({
    project,
    currentProjectId,
    users,
    userMode: getUserModeByProjectId(currentUser, currentProjectId),
    projects,
    currentUser,
  }),
);

@connect(projectContainerSelector)
class ProjectContainer extends Component {
  static propTypes = {
    currentUser: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    project: PropTypes.instanceOf(Map),
    projects: PropTypes.instanceOf(Map),
    currentProjectId: PropTypes.string,
    userMode: PropTypes.string,
    params: PropTypes.object,
    location: PropTypes.object,
    routeParams: PropTypes.object,
    children: PropTypes.object,
  };

  componentWillMount() {
    const { dispatch, currentProjectId, params, currentUser } = this.props;
    const projectId = params.projectId;

    if (projectId !== currentProjectId) {
      dispatch(ProjectActions.resetReducers(currentUser.get('id')));
    }

    dispatch(ProjectActions.getProject(projectId)).then((res) => {
      if (!res.error) {
        dispatch(ProjectActions.setCurrentProjectId(projectId));
        dispatch(ElementTypeActions.getProjectElementTypes(projectId)).then(res => {
          const WBSTypeId = Object.keys(res.result.entities.elementTypes).filter(
            et =>
              res.result.entities.elementTypes[et].type ===
              'Work Breakdown Structure',
          );

          if (WBSTypeId.length)
            dispatch(ElementTypeActions.getElementsByType(WBSTypeId[0]));
        });
        dispatch(ProjectActions.getProjectMappings(projectId));
        dispatch(RelationshipTypeActions.getProjectRelationshipTypes(projectId));
        dispatch(ProjectActions.getRootElement(projectId));
        dispatch(ProjectActions.getIcons(projectId));
        dispatch(UserActions.getProjectUsers(projectId));
      } else {
        dispatch(push('/projects'));
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, currentUser, currentProjectId } = this.props;
    const { params: { projectId } } = nextProps;

    if (currentProjectId && currentProjectId !== projectId) {
      dispatch(ProjectActions.resetReducers(currentUser.get('id')));
      dispatch(ProjectActions.setCurrentProjectId(projectId));
      dispatch(
        ElementTypeActions.getProjectElementTypes(projectId),
      ).then(res => {
        const WBSTypeId = Object.keys(res.result.entities.elementTypes).filter(
          et =>
            res.result.entities.elementTypes[et].type ===
            'Work Breakdown Structure',
        );

        if (WBSTypeId.length)
          dispatch(ElementTypeActions.getElementsByType(WBSTypeId[0]));
      });
      dispatch(AuthActions.getMeProjects());
      dispatch(ProjectActions.getProjectMappings(projectId));
      dispatch(RelationshipTypeActions.getProjectRelationshipTypes(projectId));
      dispatch(ProjectActions.getRootElement(projectId));
      dispatch(ProjectActions.getIcons(projectId));
      dispatch(UserActions.getProjectUsers(projectId));
      dispatch(ProjectActions.getProject(projectId)).then((res) => {
        if (res.error) dispatch(push('/login'));
      })
    }
  }

  render() {
    const { routeParams, project, userMode, children, location } = this.props;

    if (!project) return null;

    return (
      <Project
        routeParams={routeParams}
        project={project}
        userMode={userMode}
        location={location}
      >
        {children}
      </Project>
    );
  }
}

export default ProjectContainer;



// WEBPACK FOOTER //
// ./src/views/Project/ProjectContainer.js